/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unknown-property */
import { faExclamation, faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Row,
  CardFooter,
  Table,
} from "reactstrap";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import ButtonIcon from "../common/ButtonIcon";
import FalconCardHeader from "../common/FalconCardHeader";
import Flex from "../common/Flex";
import PageHeader from "../common/PageHeader";
import { getAllVigilants } from "../../helpers/api/security";
import {
  isIterableArray,
  Message,
  Or,
  PreloadState,
} from "../UI/preloading/PreloadState";
import FullPagination from "../common/pagination/FullPagination";
import VigilantRow from "./components/VigilantRow";
import Filter from "../common/Filter";
import classNames from "classnames";
import SupportLink from "../root/support/components/SupportLink";

const Vigilants = () => {
  const history = useHistory();
  const {
    condominium: { selectedCondominium },
    auth: {
      user: { role },
    },
  } = useSelector((state) => state);
  const [textSearch, setTextSearch] = useState("");
  const [params, setParams] = useState({
    condominium: selectedCondominium,
    isProvider: false,
    search: null,
  });

  useEffect(() => {
    setParams((prev) =>
      prev.condominium === selectedCondominium
        ? prev
        : { ...prev, condominium: selectedCondominium }
    );
  }, [selectedCondominium]);

  const applySafetySearch = (value = textSearch) => {
    const term = typeof value === "string" ? value.trim() : "";
    setTextSearch(term);
    setParams((prev) => ({ ...prev, search: term || null }));
  };
  const filter_options = [
    { value: 0, displayName: "Contratado", disabled: false },
    { value: 1, displayName: "Pertenecientes a un proveedor", disabled: false },
  ];
  const {
    data,
    error,
    isLoading,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(getAllVigilants, params);

  return (
    <>
      <PageHeader
        title="Vigilantes"
        titleTag="h2"
        description={
          role === "manager"
            ? "Gestiona los vigilantes en el condominio."
            : "Visualiza los vigilantes de tu condominio."
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>
      <Card>
        <FalconCardHeader title="Vigilantes">
          <Row className="justify-content-between">
            <Col>
              <Flex>
                <Filter
                  keyField="isProvider"
                  options={filter_options}
                  selectType={setParams}
                  dateFilter={false}
                />
              </Flex>
            </Col>
            {role === "manager" && (
              <>
                <Col
                  xs={12}
                  md={"auto"}
                  align="center"
                  className=" mt-3 mt-md-0 justify-content-center justify-content-md-end"
                >
                  <ButtonIcon
                    icon={faPlus}
                    color="falcon-default"
                    onClick={() =>
                      history.push("/dashboard/security/vigilants/create")
                    }
                  >
                    Añadir vigilante
                  </ButtonIcon>
                </Col>
              </>
            )}
          </Row>
          <Row className="mt-3">
            <Col className="d-flex">
              <Input
                type="text"
                value={textSearch}
                onKeyPress={(event) => {
                  if (event.key === "Enter") applySafetySearch(event.target.value);
                }}
                onChange={(event) => {
                  const value = event.target.value;
                  setTextSearch(value);
                  if (!value.trim()) {
                    setParams((prev) => ({ ...prev, search: null }));
                  }
                }}
                placeholder="Buscar por nombre, usuario, cédula, teléfono, correo o proveedor..."
                className="search-input mr-2"
              />
              <ButtonIcon
                icon={faSearch}
                color="falcon-default"
                className="text-nowrap"
                onClick={() => applySafetySearch()}
              >
                Buscar
              </ButtonIcon>
            </Col>
          </Row>
        </FalconCardHeader>
        <CardBody
          className={classNames("fs--1", { "p-0": isIterableArray(data) })}
        >
          <PreloadState cond={isIterableArray(data)} loading={isLoading}>
            <Or value={true}>
              <Table
                responsive
                striped
                style={{ overflow: "hidden" }}
                className="mb-0"
              >
                <thead>
                  <tr>
                    <th className="text-center align-middle"></th>
                    <th className="text-center align-middle">DNI</th>
                    <th weight="40%" className="align-middle">
                      Nombre
                    </th>
                    <th className="text-center align-middle">N° de teléfono</th>
                    <th className="text-center align-middle">
                      Fecha de creación
                    </th>
                    <th weight="10%" className="text-center align-middle">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, i) => (
                    <VigilantRow key={i} role={role} {...item} />
                  ))}
                </tbody>
              </Table>
            </Or>
            <Or value={false} cond={!!error}>
              <Or value={false} cond={role}>
                <Message
                  value={"manager"}
                  color={"info"}
                  className="p-3"
                  align="left"
                  icon={faExclamation}
                >
                  No hay vigilantes registrados,
                  puede registrar un nuevo vigilante presionando en el botón de arriba "Añadir vigilante".
                </Message>
                <Message
                  value={"property"}
                  color={"info"}
                  className="p-3"
                  align="left"
                  icon={faExclamation}
                >
                  No hay vigilantes registrados.
                </Message>
              </Or>
              <Message
                value={true}
                color={"danger"}
                className="p-3"
                align="left"
                icon={faExclamation}
              >
                <>
                  Esta página no está disponible
                  <Button
                    data-testid="Button"
                    color="link"
                    size="sm"
                    className="ml-1 pl-0"
                    onClick={() => history.goBack()}
                  >
                    Volver
                  </Button>
                </>
              </Message>
            </Or>
          </PreloadState>
        </CardBody>
        {isIterableArray(data) && (
          <CardFooter className="border-top">
            <FullPagination
              nextPage={nextPage}
              prevPage={previousPage}
              goToPage={goToPage}
              meta={meta}
              className={"shadow-none"}
              posText={"vigilantes"}
              perPage={perPage}
            />
          </CardFooter>
        )}
      </Card>
    </>
  );
};

export default Vigilants;
